<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-comment-question</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">問い合わせ閲覧</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="4">
                    <p class="ml-5 mt-4">名前<p/>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="mt-1 mr-5" v-model="name" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4">
                    <p class="ml-5 mt-4">メールアドレス<p/>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="mt-1 mr-5" v-model="email" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4">
                    <p class="ml-5 mt-4">問い合わせ番号<p/>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="mt-1 mr-5" v-model="inquiry_number" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4">
                    <p class="ml-5 mt-4">ステータス<p/>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="mt-1 mr-5" v-model="status" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4">
                    <p class="ml-5 mt-5">タイトル<p/>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="mt-1 mr-5" v-model="title" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <p class="ml-5 mt-3">問い合わせ内容<p/>
                    <v-textarea class="mt-1 ml-5 mr-5" v-model="content" rows="10" dense outlined readonly></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'Inquiry' }" depressed>キャンセル</v-btn>
            <v-btn color="success" v-bind:disabled="statusFlag" @click.prevent="statusChangeDialog" depressed>ステータス変更</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="changeStatusVisible" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">ステータス変更
          </v-card-title>
          <v-card-actions>
            <v-spacer>
              <v-col cols="12">
                <v-col cols="6">
                <v-select @change="statusChange" v-model="select_status" :items="status_list" item-text="name" item-value="value" max-width="10" no-data-text="データがありません" dense outlined return-object>
                </v-select>
                </v-col>
              </v-col>
              <v-row>
                <v-col class="ml-8">
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" class="mr-3" @click.stop="changeStatusCancelHandler" depressed>キャンセル</v-btn>
                    <v-btn color="success" @click.prevent="submit" depressed>ステータス変更</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import InquiriesApi from "@/api/inquiries-api";
import statusList from "@/helpers/const";

export default {
  name: "InquiryInfo",
  data: () => ({
    loading: false,
    // 名前
    name: "",
    // メールアドレス
    email: "",
    // 問い合わせ番号
    inquiry_number: "",
    // ステータス
    status: "",
    // タイトル
    title: "",
    // 問い合わせ内容
    content: "",
    //ステータスフラグ
    statusFlag: false,
    // ステータス変更ダイアログ
    select_status: "解決",
    status_list: [
        { id: 1, name: "保留" },
        { id: 2, name: "解決" },
      ],
    changeStatusId: 2,
    changeStatusVisible: false,
    id: null
  }),
  created() {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      this.inquiriesApi = new InquiriesApi();
      // 問い合わせ番号をルートパラメータから取得
      this.id = this.$route.params.id;
      const promise = this.inquiriesApi.info(this.id);
      promise.then(response => {
        this.name = response.data.body.inquiries_info.name;
        this.email = response.data.body.inquiries_info.email;
        this.inquiry_number = ( '000000' + response.data.body.inquiries_info.inquiry_number ).slice( -6 );
        const inquiry_status = response.data.body.inquiries_info.status;
        if (inquiry_status == 0){
          this.status = "未解決";
        } else if (inquiry_status == 1){
          this.status = "保留";
          // ステータスが保留のときは解決のみ表示
          this.status_list = { id: 2, name: "解決" };
        } else {
          this.status = "解決";
          this.statusFlag = true;
        }
        this.title = response.data.body.inquiries_info.title;
        this.content = response.data.body.inquiries_info.content;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          this.$emit("error",error.response.data.message);
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$router.push({ name: "InquiryInfo" })
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    //ステータス変更(ダイアログ表示)ボタン押下時
    statusChangeDialog() {
      this.changeStatusVisible = true;
      this.changeStatusId = 2;
      this.select_status = "解決";
    },
    changeStatusCancelHandler() {
      this.changeStatusVisible = false;
    },
    //ステータス変更イベント
    statusChange(id_num) {
      this.changeStatusId = id_num.id;
    },
    //ステータス変更(実行)ボタン押下時
    submit() {
      this.isLoading();
      const params = {
          status: this.changeStatusId,
      };
      const promise = this.inquiriesApi.update(this.id, params);
      promise.then(response => {
        this.changeStatusVisible = false;
        this.initialize();
        this.$emit("success", response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
  },
};
</script>
